import { IDeferred } from "angular";
import { ErrorMessage, PropertyMessage } from "../../app/shared/model/properties.model";
import { IEditableFormController } from "./assets.model";
 
$(document).ready(() => {
	$('body').tooltip({ selector: '[data-toggle=tooltip]' });
});

const standardDeviation = (values: number[]) => {
	let avg = average(values);

	let squareDiffs = values.map((value: number) => {
		let diff = value - avg;
		let sqrDiff = diff * diff;

		return sqrDiff;
	});

	let avgSquareDiff = average(squareDiffs);

	let stdDev = Math.sqrt(avgSquareDiff);

	return stdDev;
}

const average = (data: number[]) => {
	let sum = data.reduce((sum, value) => {
		return sum + value;
	}, 0);

	let avg = sum / data.length;
	
	return avg;
}

const handleFormError = (deferred: IDeferred<any>, form: IEditableFormController, errors: PropertyMessage[] | ErrorMessage | string) => {
	deferred.reject('error');

	if (Array.isArray(errors)) {
		const returnErrors: PropertyMessage[] = [];

		errors.forEach(error => {
			if (form.$data && form.$data.hasOwnProperty(error.property))
				(form as any).$setError(error.property, error.message);
			else
				returnErrors.push(error);
		});

		// if (returnErrors.length)
			return returnErrors;
	}
	else if (errors instanceof Object)
		throw new Error(errors.errorMessage);
	else
		throw new Error(errors);
}

const debounce = (func: Function, wait: number, immediate?: number) => {
	let timeout: number | null;

	return function(this: Window) {
		let context = this, args = arguments;

		let later = function() {
			timeout = null;

			if (!immediate)
				func.apply(context, args);
		};

		let callNow = immediate && !timeout;
		if (timeout)
			clearTimeout(timeout);

		timeout = window.setTimeout(later, wait);

		if (callNow)
			func.apply(context, args);
	};
};

const preg_quote = (str: string, delimiter?: string) => { // eslint-disable-line camelcase
	//  discuss at: http://locutus.io/php/preg_quote/
	// original by: booeyOH
	// improved by: Ates Goral (http://magnetiq.com)
	// improved by: Kevin van Zonneveld (http://kvz.io)
	// improved by: Brett Zamir (http://brett-zamir.me)
	// bugfixed by: Onno Marsman (https://twitter.com/onnomarsman)
	//   example 1: preg_quote("$40")
	//   returns 1: '\\$40'
	//   example 2: preg_quote("*RRRING* Hello?")
	//   returns 2: '\\*RRRING\\* Hello\\?'
	//   example 3: preg_quote("\\.+*?[^]$(){}=!<>|:")
	//   returns 3: '\\\\\\.\\+\\*\\?\\[\\^\\]\\$\\(\\)\\{\\}\\=\\!\\<\\>\\|\\:'
	return (str + '')
		.replace(new RegExp('[.\\\\+*?\\[\\^\\]$(){}=!<>|:\\' + (delimiter || '') + '-]', 'g'), '\\$&')
}

const arraymove = (arr: [], fromIndex: number, toIndex: number) => {
	let element = arr[fromIndex];
	arr.splice(fromIndex, 1);
	arr.splice(toIndex, 0, element);
}

const entityMap = {
	'&': '&amp;',
	'<': '&lt;',
	'>': '&gt;',
	'"': '&quot;',
	"'": '&#39;',
	'/': '&#x2F;',
	'`': '&#x60;',
	'=': '&#x3D;'
};

const escapeHtml = (string: string) => {
	return String(string).replace(/[&<>"'`=\/]/g, s => {

		return entityMap[s as keyof typeof entityMap];
	})
};

export { standardDeviation, average, handleFormError, debounce, preg_quote, arraymove, escapeHtml };